import type { FocusedLead } from '../data';

const CLOSED_LOST_STAGE = 'Closed lost';

/**
 * Texting from Coffee is limited to demo confirmations and reschedules. The API
 * only returns `lastDeal` while the deal is open (future meeting, or a meeting
 * within the reschedule window), so its presence is the "live demo" signal; a
 * deal already marked lost is excluded even inside that window.
 */
export function hasActiveDemo(lead: Pick<FocusedLead, 'lastDealIsOpen' | 'dealStage'> | undefined): boolean {
	if (!lead?.lastDealIsOpen) return false;
	return (lead.dealStage ?? '').trim().toLowerCase() !== CLOSED_LOST_STAGE.toLowerCase();
}
